import googleTagManager from "@analytics/google-tag-manager";

export const GOOGLE_TAG_MANAGER_PLUGIN = googleTagManager({
  containerId: process.env.GATSBY_GOOGLE_TAG_MANAGER_CONTAINER_ID || "",
});
